define('chart-config',['lib/utils', 'highcharts'],

    function(utils, Highcharts) {

        'use strict';

        var ChartConfig = function() {

                Highcharts.setOptions({
                    lang: {
                        thousandsSep: ""
                    },
                    chart: {
                        style: {
                            fontFamily: utils.isRTL() ? 'DUBAI-REGULAR' : 'DUBAI-REGULAR',
                            fontWeight: 100
                        }
                    },
                    plotOptions: {
                        line: {
                            marker: {
                                symbol: 'circle'
                            }
                        }
                    },
                    credits: {
                        enabled: false
                    }
                });

            },

            _singleton;

        _singleton = new ChartConfig();

        return _singleton;
    });

